module.exports = __webpack_public_path__ + "static/media/高分六号卫星.1e331a04.png";